import React, { useState, useCallback } from "react";

// libs
import { Row, Spin, Tooltip, Icon, Col } from "antd";
import moment from "moment";

// Styles
import { Card } from "../../styles";

// Components
import useKpiContext from "../../../../hooks/useKpiContext";

//Services
import { numberMask } from "../../../../services/helpersMethodsService";

//Icons
import AlertIcon from "../../icons/alert";
import ChartIcon from "../../icons/chart";
import InfoIcon from "../../../../components/utils/icons/info";

const KpiGDP = () => {
  const { kpiGDP: kpiData, kpiGMD, kpiGP, updateKpiSelected } = useKpiContext();
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isTooltipErrorVisible, setIsTooltipErrorVisible] = useState(false);

  const handleShowTooltip = useCallback(() => {
    setIsTooltipVisible(true);
    setTimeout(() => {
      setIsTooltipVisible(false);
    }, 2000);
  }, []);

  const handleShowTooltipError = useCallback(() => {
    setIsTooltipErrorVisible(true);
    setTimeout(() => {
      setIsTooltipErrorVisible(false);
    }, 2000);
  }, []);

  return (
    <Card
      xs={23}
      sm={23}
      md={23}
      lg={7}
      xl={7}
      className={
        (kpiData?.data?.isComplete
          ? kpiData?.data?.goalAchieved
            ? " border-bottom-green"
            : " border-bottom-red"
          : "") +
        (kpiData.isSelected
          ? kpiData?.data?.isComplete
            ? kpiData?.data?.goalAchieved
              ? " border-green"
              : " border-red"
            : " border-yellow"
          : "")
      }
      onClick={() => (!kpiData.isLoading ? updateKpiSelected("GDP") : null)}
    >
      <Spin spinning={kpiData.isLoading} size="small">
        <Row type="flex" justify="start">
          <Col span={8}>
            <div className="header">
              <span>
                <Tooltip
                  visible={isTooltipErrorVisible}
                  title={`Último processamento: ${
                    kpiData.data?.kpiDate != null
                      ? moment(kpiData.data.kpiDate).format("DD/MM/YYYY")
                      : "Sem data"
                  }`}
                >
                  {kpiData.data.error ? (
                    <Icon
                      type="exclamation-circle"
                      className="iconError"
                      theme="filled"
                      onClick={() => handleShowTooltipError()}
                    />
                  ) : null}
                </Tooltip>
                GDP
              </span>
            </div>
            <div className="content">
              <Row type="flex">
                <span className="span-font">
                  <b>
                    {kpiData.data?.kpiValue == null
                      ? "-"
                      : numberMask(
                          kpiData.data?.kpiValue || 0,
                          kpiData.data?.isMonetary
                        )}{" "}
                  </b>
                  {kpiData.data?.valueType}
                </span>
              </Row>
            </div>
          </Col>
          <Col span={8}>
            <div className="header">
              <span>GP PROJ.</span>
            </div>
            <div className="content">
              <Row type="flex">
                <Tooltip
                  visible={isTooltipVisible}
                  placement="top"
                  title="Ganho de Peso total em relação ao dia anterior"
                >
                  <span className="span-font">
                    <b>
                      {kpiGP.data?.kpiValue == null
                        ? "-"
                        : numberMask(
                            kpiGP.data?.kpiValue || 0,
                            kpiGP.data?.isMonetary
                          )}{" "}
                    </b>
                    {kpiGP.data?.valueType}
                  </span>
                </Tooltip>
              </Row>
            </div>
          </Col>
          <Col span={8}>
            <div className="header">
              <span>GMD PROJ.</span>
              <span>
                {!kpiData?.data?.isComplete ? null : kpiData?.data
                    ?.goalAchieved ? (
                  <ChartIcon />
                ) : (
                  <AlertIcon />
                )}
              </span>
            </div>
            <div className="content">
              <Row type="flex">
                <Tooltip
                  visible={isTooltipVisible}
                  placement="right"
                  title="Ganho médio, por animal, em relação ao dia anterior"
                >
                  <span className="span-font">
                    <b>
                      {kpiGMD.data?.kpiValue == null
                        ? "-"
                        : numberMask(
                            kpiGMD.data?.kpiValue || 0,
                            kpiGMD.data?.isMonetary
                          )}{" "}
                    </b>
                    {kpiGMD.data?.valueType}
                  </span>
                </Tooltip>
              </Row>
              <Row type="flex" justify="end" gutter={8}>
                <InfoIcon onClick={() => handleShowTooltip()} />
              </Row>
            </div>
          </Col>
        </Row>
        <div className="content-footer">
          <Tooltip visible={isTooltipVisible} title="Idade média do rebanho">
            <span>
              <b>{kpiData.data?.parameters?.AVGAnimalsAgeInMonths || 0} </b>
              meses
            </span>
          </Tooltip>
          <Tooltip
            placement="bottom"
            visible={isTooltipVisible}
            title="Diferença entre o animal mais novo e o mais velho"
          >
            <span>
              <b>
                {kpiData.data?.parameters?.AnimalsAgeDifferenceInMonths || 0}{" "}
              </b>
              meses
            </span>
          </Tooltip>
        </div>
      </Spin>
      {!kpiData?.data?.isComplete ? <div className="banner-image" /> : null}
    </Card>
  );
};

export default KpiGDP;
